export default __webpack_public_path__ + "static/media/second-step-doppelhaushalfte.d185b753.svg";